import React from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import StaticLink from 'components/staticLink/StaticLink';
import I18n from 'components/translate/I18n';
import { STATIC_LINKS } from 'modules/dashboard/constants';
import { FeatureToggles, FeatureToggleService } from 'modules/featureToggle';
import PropTypes from 'prop-types';

import ConfirmationModal from '../ConfirmationModal';
import ConfirmationModalInfo from '../ConfirmationModalInfo';

const ActivateModal = ({ isOpen, onConfirm, onCancel }) => {
  const deviceList = FeatureToggleService.isEnabled(
    FeatureToggles.ConfigDrmDeviceList
  );

  return (
    <ConfirmationModal
      title="config_manager.config_streaming.activate_drm_modal.title"
      subtitle="config_manager.config_streaming.activate_drm_modal.description"
      confirmLabel="config_manager.config_streaming.activate_drm_modal.confirm"
      isOpen={isOpen}
      onConfirm={onConfirm}
      onCancel={onCancel}
    >
      <ConfirmationModalInfo
        icon="users"
        label="config_manager.config_streaming.activate_drm_modal.info_1"
      >
        {' '}
        {deviceList && (
          <StaticLink links={STATIC_LINKS.DRM_COMPATIBLE_DEVICES}>
            <I18n label="config_manager.config_streaming.activate_drm_modal.compatible_devices" />
            <FontAwesomeIcon
              icon={['fal', 'external-link']}
              className="_ml-2"
            />
          </StaticLink>
        )}
      </ConfirmationModalInfo>
      <ConfirmationModalInfo
        icon="user-clock"
        label="config_manager.config_streaming.activate_drm_modal.info_2"
      />
      <ConfirmationModalInfo
        icon="download"
        label="config_manager.config_streaming.activate_drm_modal.info_3"
      />
      <ConfirmationModalInfo
        icon="shield"
        label="config_manager.config_streaming.activate_drm_modal.info_4"
      />
      <ConfirmationModalInfo
        icon="spinner"
        label="config_manager.config_streaming.activate_drm_modal.info_5"
      />
    </ConfirmationModal>
  );
};

ActivateModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onConfirm: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired
};

export default ActivateModal;
